__turbopack_context__.v({
  "enter": "animations-module-scss-module__fJxM3a__enter",
  "exit": "animations-module-scss-module__fJxM3a__exit",
  "fade-in": "animations-module-scss-module__fJxM3a__fade-in",
  "fade-out": "animations-module-scss-module__fJxM3a__fade-out",
  "fade-out-80": "animations-module-scss-module__fJxM3a__fade-out-80",
  "feature-hero-float": "animations-module-scss-module__fJxM3a__feature-hero-float",
  "feature-rail-loop": "animations-module-scss-module__fJxM3a__feature-rail-loop",
  "featureHeroFloat": "animations-module-scss-module__fJxM3a__featureHeroFloat",
  "featureRailLoop": "animations-module-scss-module__fJxM3a__featureRailLoop",
  "pricing-button-glass": "animations-module-scss-module__fJxM3a__pricing-button-glass",
  "pricingButtonGlass": "animations-module-scss-module__fJxM3a__pricingButtonGlass",
  "pulse-glow": "animations-module-scss-module__fJxM3a__pulse-glow",
  "pulseGlowActive": "animations-module-scss-module__fJxM3a__pulseGlowActive",
  "sample-card-glow": "animations-module-scss-module__fJxM3a__sample-card-glow",
  "sample-marquee": "animations-module-scss-module__fJxM3a__sample-marquee",
  "sampleCardGlow": "animations-module-scss-module__fJxM3a__sampleCardGlow",
  "sampleMarquee": "animations-module-scss-module__fJxM3a__sampleMarquee",
  "slide-in-from-bottom": "animations-module-scss-module__fJxM3a__slide-in-from-bottom",
  "slide-in-from-left": "animations-module-scss-module__fJxM3a__slide-in-from-left",
  "slide-in-from-right": "animations-module-scss-module__fJxM3a__slide-in-from-right",
  "slide-in-from-top": "animations-module-scss-module__fJxM3a__slide-in-from-top",
  "slide-out-to-bottom": "animations-module-scss-module__fJxM3a__slide-out-to-bottom",
  "slide-out-to-left": "animations-module-scss-module__fJxM3a__slide-out-to-left",
  "slide-out-to-right": "animations-module-scss-module__fJxM3a__slide-out-to-right",
  "slide-out-to-top": "animations-module-scss-module__fJxM3a__slide-out-to-top",
  "zoom-in": "animations-module-scss-module__fJxM3a__zoom-in",
  "zoom-out": "animations-module-scss-module__fJxM3a__zoom-out",
});
